import React from 'react';
import PropTypes from 'prop-types';
import { IoIosArrowForward } from 'react-icons/io';
import { IoIosArrowBack } from 'react-icons/io';

import styles from './slider-navigation.module.css';

const SliderNavigation = ({
  prevSlide,
  nextSlide,
  activeSlide,
  sliderLength,
  navType,
  navPos,
  color,
}) => {
  const handleNextClick = () => {
    nextSlide();
  };
  const handlePrevClick = () => {
    prevSlide();
  };
  return (
    <div
      className={
        navType === 'case-study'
          ? [styles.wrapper, styles.csNav].join(' ')
          : styles.wrapper
      }
      style={{ bottom: `${navPos}em`, color: `#${color}` }}
    >
      <IoIosArrowBack onClick={handlePrevClick} />
      <div className={styles.numbered}>
        {activeSlide + 1} / {sliderLength}
      </div>
      <IoIosArrowForward onClick={handleNextClick} />
    </div>
  );
};

SliderNavigation.propTypes = {
  prevSlide: PropTypes.func,
  nextSlide: PropTypes.func,
  activeSlide: PropTypes.number,
  sliderLength: PropTypes.number,
  navType: PropTypes.string,
  navPos: PropTypes.number,
  color: PropTypes.string,
};

export default SliderNavigation;



// WEBPACK FOOTER //
// ./src/components/slider/slider-navigation/index.js